var _componentCKEditor = function($context) {
    if (typeof CKEDITOR == 'undefined') {
        console.warn('Warning - ckeditor.js is not loaded.');
        return;
    }
    
    var ci_ckeditor_instances = 0;
    var initHandler = function($editor, options) {    
        ci_ckeditor_instances++;
        if ($editor.attr('id') === undefined) {        
            $editor.attr('id', 'ci-ckeditor-' + ci_ckeditor_instances);
        }
        CKEDITOR.replace($editor.attr('id'), options);
    };
    
    $context = $context instanceof jQuery ? $context : $(document);

    // Setup       
    $context.find('.js-ckeditor-full').each(function () {
        initHandler($(this), {
            extraPlugins: 'forms'
        });
    });       
    $context.find('.js-iframe-ckeditor').each(function () {
        initHandler($(this), {
            extraPlugins : 'wordcount,uploadimage,quicktable,texttransform,simplebutton,wenzgmap' 
        });
    });
    $context.find('.js-minimal-ckeditor').each(function () {
        initHandler($(this), {
            toolbar: 'MinimalHTML',
            allowedContent: true
        });
    });
};

var _componentSelect2 = function($context) {
    if (!$().select2) {
        console.warn('Warning - select2.min.js is not loaded.');
        return;
    };

    // Default initialization
    ($context instanceof jQuery ? $context.find('.form-control-select2') : $('.form-control-select2')).select2({
        minimumResultsForSearch: Infinity
    });
};

function init($context) {
    _componentCKEditor($context);
    _componentSelect2($context);
}

export const CKEditor = {
    init
}